// Where a signed-in user lands when they haven't asked for a specific page:
// after logging in, or when they open /login, /signup or the landing page
// while already authenticated.
//
// The flows board is the entry point because it answers the first question of
// the day — どのリストがどの段にいるか — for every batch of work at once, and
// says which one needs a hand next. The chat that can do the whole job by
// conversation, and the per-step screens, stay one click away in the sidebar.
export const HOME_ROUTE = '/flows'
